
import { fetchWithTrace } from './fetchWithTrace';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

/**
 * Validates an image against backend safety policies.
 * @param {string} b64Data - Base64 string of the image (without data URI prefix ideally, or backend handles it)
 * @param {string} mimeType - e.g. 'image/jpeg'
 * @returns {Promise<{allowed: boolean, reason?: string}>}
 */
export async function validateImageContent(imageInput, mimeType = 'image/png') {
    try {
        let bodyPayload = {};

        // Check if input is base64 or URL
        if (imageInput.startsWith('http') || imageInput.startsWith('//')) {
            bodyPayload = { imageUrl: imageInput, mimeType };
        } else {
            // Assume base64
            const cleanB64 = imageInput.replace(/^data:image\/[a-z]+;base64,/, '');
            bodyPayload = { image: cleanB64, mimeType };
        }

        const response = await fetchWithTrace(`${API_URL}/api/safety/validate-image`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodyPayload,
        });

        if (response.data) {
            return response.data;
        }
        return { allowed: false, reason: "No response data" };
    } catch (err) {
        console.error("Safety check error:", err);
        // Fail closed on network error too? 
        // UX decision: User sees "Safety check failed (Network)", can retry.
        return { allowed: false, reason: "Validation network error" };
    }
}
